import { AppBar, Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface IEHTOntarioDueRemittanceTransacitonsToolbar {
	onProcessedOnEhtOntarioWebsiteButtonClickedHandler: () => void
	onDeleteButtonClickedHandler: () => void
	onSaveButtonClickedHandler: () => void
}

export const EHTOntarioDueRemittanceTransacitonsToolbar: FC<IEHTOntarioDueRemittanceTransacitonsToolbar> = ({
	onProcessedOnEhtOntarioWebsiteButtonClickedHandler,
	onDeleteButtonClickedHandler,
	onSaveButtonClickedHandler,
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
			}}
		>
			<Toolbar>
				<EnhancedButtonPrimeReact
					label="Save"
					onClickHandler={onSaveButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					label="Processed on EHT Ontario websire"
					onClickHandler={onProcessedOnEhtOntarioWebsiteButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				/>
			</Toolbar>
		</AppBar>
	);
};
